import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core";
import { Box, Grid, Typography, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormBuilderService from "../../services/form-builder.service";
import { FormStore } from "../../services/form.store";
import { Autocomplete } from "@material-ui/lab";

const styles = (theme) => ({
  formLabel: {
    padding: "0px 2px",
  },
  formControl: {
    margin: theme.spacing(1),
    borderRadius: 4,
    border: "1px solid grey",
    padding: "10px",
    width: "100%",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  MuiPaper: {
    width: "100%",
  },
});

class LinkPrompt extends Component {
  constructor(props) {
    super();
    this.state = {
      prompts: [],
      selectedPrompt: props.selectedPrompt || null,
    };
    this.formBuilderService = new FormBuilderService();
  }

  componentDidMount() {
    this.formBuilderService
      .getPromptList()
      .then((response) => {
        this.setState({
          prompts: response.data,
        });
      })
      .catch((err) => {
        return err;
      });
  }

  onChangePrompt = (event, value) => {
    if (event.target.value !== undefined) {
      this.setState({
        selectedPrompt: value,
      });
    }
  };

  onSubmit = () => {
    if (this.state.selectedPrompt) {
      FormStore.sharedInstance().assignLinkedPromptToQuestion(
        this.state.selectedPrompt,
      );
    }
    this.props.onClose();
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          open={true}
          classes={{ paper: classes.MuiPaper }}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="dialog-title">Link Prompt</DialogTitle>
          <DialogContent>
            <Box p={3}>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Typography className={classes.formLabel}>Prompts</Typography>
                  <FormControl fullWidth variant="outlined">
                    <Autocomplete
                      id="linkedPrompts"
                      options={this.state.prompts}
                      onChange={this.onChangePrompt}
                      value={this.state.selectedPrompt || null}
                      getOptionLabel={(option) =>
                        option || ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select Prompt"
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.onClose}
              variant="contained"
              id="cancel"
              color="secondary"
            >
              Cancel
            </Button>
            <Button onClick={this.onSubmit} variant="contained" id="save">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(LinkPrompt);